// plugins/apiClient.ts
import { defineNuxtPlugin } from '#app';
import apiClient, { type ApiClientInstance } from '~/api/apiFetchClient';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const baseUrl = config.public.localAPI

  if(!baseUrl) {
    throw new Error('apiClient plugin | BaseURL is not set')
  }

  apiClient.setBaseURL(baseUrl)

  nuxtApp.provide('api', {
    auth: {
      verify: (payload: { code: string }) => apiClient.post(`${baseUrl}/api/auth/verify`, payload),
      tokens: () => apiClient.get(`${baseUrl}/api/auth/tokens`),
      logout: () => apiClient.post(`${baseUrl}/api/auth/logout`),
    },
    // sheets: {
    //   getSheetData: (sheetId: string) => apiClient.get(`/api/sheets/${sheetId}`),
    // },
    redis: {
      sessionInit: (payload: { sessionID: string }) => apiClient.post(`${baseUrl}/api/r/s/init`, payload),
    },
    test: {
      get: () => apiClient.get(`${baseUrl}/test`),
      test1: () => apiClient.get(`${baseUrl}/test1.php`),
    },
    // Products endpoints have been migrated to useWPApi composable
    // using WordPress REST API at /wp-json/mp/v1/products
  });

}); 
